export const MAX_UUIDS = 1000;

export type UuidCount = { ok: true; n: number; capped: boolean } | { ok: false; error: string };

/** Whole number from 1 to MAX_UUIDS. Anything else says why instead of quietly using 1. */
export function parseUuidCount(raw: string): UuidCount {
  const t = raw.trim();
  if (!t) return { ok: false, error: "Enter how many UUIDs you want." };
  const n = Number(t);
  if (!Number.isFinite(n)) return { ok: false, error: "Enter a whole number." };
  if (!Number.isInteger(n)) return { ok: false, error: "Enter a whole number, such as 5." };
  if (n < 1) return { ok: false, error: "Enter 1 or more. Zero and negative counts cannot be generated." };
  return n > MAX_UUIDS ? { ok: true, n: MAX_UUIDS, capped: true } : { ok: true, n, capped: false };
}

export function formatUuid(uuid: string, opts: { hyphens: boolean; upper: boolean }): string {
  let u = opts.hyphens ? uuid : uuid.replace(/-/g, "");
  if (opts.upper) u = u.toUpperCase();
  return u;
}
